import { PointDetailTopBar } from '@/components/point-detail-top-bar'

interface Props {
  children: React.ReactNode
}

export const PointDetailLayout = (props: Props): JSX.Element => {
  return (
    <main className="min-h-screen bg-[#F5F7FC] flex flex-col">
      <section className="grid grid-rows-[repeat(1,_75px_1fr_75px)]">
        <PointDetailTopBar />
        <div className="relative container pb-2 h-[calc(100vh-100px)] overflow-y-auto">
          {props.children}
        </div>
      </section>
    </main>
  )
}
